import { MapPin, Mail, Linkedin, Dribbble, Instagram, Twitter, MessageCircle } from "lucide-react";
import Breadcrumb from "../components/Breadcrumb";
import ScrollReveal from "../components/ScrollReveal";

const CONTACT_ITEMS = [
  {
    icon: <MapPin size={18} />,
    label: "Based In",
    val: "Mehsana, India",
    href: "#",
  },
  {
    icon: <Mail size={18} />,
    label: "Studio Email",
    val: "sinixstudio.in@gmail.com",
    href: "mailto:sinixstudio.in@gmail.com",
  },
  {
    icon: <Mail size={18} />,
    label: "Personal Email",
    val: "shubhamprajapti.hello@gmail.com",
    href: "mailto:shubhamprajapti.hello@gmail.com",
  },
  {
    icon: <MessageCircle size={18} />,
    label: "WhatsApp",
    val: "+91 91062 76865",
    href: "https://wa.me/919106276865",
  },
];

const SOCIAL_ITEMS = [
  {
    icon: <Linkedin size={18} />,
    label: "LinkedIn — Studio",
    val: "sinix-studio",
    href: "https://www.linkedin.com/company/sinix-studio/",
  },
  {
    icon: <Linkedin size={18} />,
    label: "LinkedIn — Shubham",
    val: "shubham-a-prajapati",
    href: "https://www.linkedin.com/in/shubham-a-prajapati/",
  },
  {
    icon: <Instagram size={18} />,
    label: "Instagram — Studio",
    val: "@sinixstudio.in",
    href: "https://www.instagram.com/sinixstudio.in/",
  },
  {
    icon: <Instagram size={18} />,
    label: "Instagram — Shubham",
    val: "@achhawalashubham",
    href: "https://www.instagram.com/achhawalashubham/",
  },
  {
    icon: <Dribbble size={18} />,
    label: "Dribbble",
    val: "shubhamprajapati-hello",
    href: "https://dribbble.com/shubhamprajapati-hello",
  },
  {
    icon: <Twitter size={18} />,
    label: "X (Twitter)",
    val: "@achawalashubham",
    href: "https://x.com/achawalashubham",
  },
];

export default function Contact() {
  return (
    <div className="page" data-testid="contact-page">
      <section className="page-hero">
        <div className="container-x">
          <Breadcrumb items={[{ label: "Home", to: "/" }, { label: "Contact", to: "/contact" }]} />
          <h1 style={{ marginTop: 16 }}>Let's Build Something.</h1>
          <p className="lead">Available for freelance projects, monthly retainers and remote collaborations.</p>
        </div>
      </section>

      <section className="section section-bright">
        <div className="container-x">
          <ScrollReveal>
            <div className="contact-info-card" data-testid="contact-info-card" style={{ maxWidth: 720, margin: "0 auto" }}>
              <h3 style={{ fontSize: 24, marginBottom: 8 }}>Reach me directly</h3>
              <p style={{ color: "var(--slate-grey)", fontSize: 15, marginBottom: 28 }}>
                Drop an email, WhatsApp or connect on socials — I usually respond within 24 hours.
              </p>

              {/* Primary Contact */}
              <div style={{ display: "flex", flexDirection: "column", gap: 4, marginBottom: 28 }}>
                {CONTACT_ITEMS.map((item) => (
                  <a
                    key={item.label}
                    className="info-item"
                    href={item.href}
                    target={item.href.startsWith("http") ? "_blank" : undefined}
                    rel="noreferrer"
                    data-testid={item.label === "Studio Email" ? "contact-email" : undefined}
                  >
                    <div className="ic">{item.icon}</div>
                    <div>
                      <div className="lbl">{item.label}</div>
                      <div className="val">{item.val}</div>
                    </div>
                  </a>
                ))}
              </div>

              {/* Divider */}
              <div style={{ borderTop: "1px solid var(--alabaster-grey)", marginBottom: 24 }} />

              {/* Social Links - 2 column grid */}
              <p style={{ fontFamily: "var(--font-mono)", fontSize: 11, textTransform: "uppercase", letterSpacing: "0.12em", color: "var(--pale-slate-2)", fontWeight: 500, marginBottom: 16 }}>
                Socials
              </p>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: 4 }}>
                {SOCIAL_ITEMS.map((item) => (
                  <a
                    key={item.label}
                    className="info-item"
                    href={item.href}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div className="ic">{item.icon}</div>
                    <div>
                      <div className="lbl">{item.label}</div>
                      <div className="val" style={{ fontSize: 13 }}>{item.val}</div>
                    </div>
                  </a>
                ))}
              </div>

              <div className="avail-row">
                <strong>Available for</strong> · Freelance · Retainers · Remote
              </div>
            </div>
          </ScrollReveal>
        </div>
      </section>
    </div>
  );
}
